export type WidgetLocale = "fr" | "en";

export const resolveWidgetLocale = (input: string | undefined | null): WidgetLocale => {
  if (!input) return "en";
  const head = input.toLowerCase().split(/[-_]/)[0];
  return head === "fr" ? "fr" : "en";
};
